import { useTranslation } from 'react-i18next';
import { StatusChip, StatusTone } from '@/components/core';

interface StatusPresentation {
  tone: StatusTone;
  /** Existing UILM key for the status label. */
  labelKey: string;
}

/** Every status used by the five legacy workflows, mapped to its existing UILM label key. */
const STATUS_PRESENTATION: Record<string, StatusPresentation> = {
  Pending: { tone: 'warning', labelKey: 'PENDING' },
  InProgress: { tone: 'info', labelKey: 'IN_PROGRESS' },
  Approved: { tone: 'success', labelKey: 'APPROVED' },
  Accepted: { tone: 'success', labelKey: 'APPROVED' },
  Completed: { tone: 'success', labelKey: 'COMPLETED' },
  Generated: { tone: 'success', labelKey: 'GENERATED' },
  Delivered: { tone: 'success', labelKey: 'DELIVERED' },
  Rejected: { tone: 'error', labelKey: 'REJECTED' },
  Canceled: { tone: 'error', labelKey: 'CANCELED' },
  Excluded: { tone: 'error', labelKey: 'EXCLUDED' },
  Archived: { tone: 'muted', labelKey: 'ARCHIVED' },
};

/** The UILM key a status is shown with (the raw status when it has none). */
export const statusLabelKey = (status: string) => STATUS_PRESENTATION[status]?.labelKey ?? status;

export const StatusBadge = ({ status }: { status: string }) => {
  const { t } = useTranslation();
  const presentation = STATUS_PRESENTATION[status];

  return (
    // `status` gives the chip its own icon (In Progress, Generated, Delivered, Canceled, Excluded, Archived).
    <StatusChip tone={presentation?.tone ?? 'muted'} status={status}>
      {presentation ? t(presentation.labelKey) : status}
    </StatusChip>
  );
};
